import { AppState } from "./Enums";


class App {

    private totalConversations = 0;
    
    /**
     * header classes
     */
    public classes: any = {
        header: {
            height: {
                [AppState.home]: "height-header-home",
                [AppState.chat]: "height-header-chat-small",
                [AppState.allConversations]: "height-header-all-conversations"
            }
        }
    }
    /**
     * sets total conversations
     * @param {number} totalCoversations 
     */
     setTotalConversations = (totalCoversations: number) => {
        this.totalConversations = totalCoversations;
    }
    /**
     * returns Total Conversations
     * @returns {number}
     */
    getTotalConversations = () => {
        return this.totalConversations;
    }
    /**
     * returns hide class associated with the state
     * @param {AppState} index states property value
     * @returns {string} returns hide class name associated with the state
     */
    public getClassHeightHeader = (appState: AppState) => {
        if (!this.classes.header.height[appState]) return "";
        return this.classes.header.height[appState];
    }
}

// export App class instance (singleton)
export const __app = new App();